import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const ScribbleReveal = ({
  d,
  viewBox,
  className = "",
  strokeClassName = "text-[#A6E2F4]",
  strokeWidth = 12,
  duration = 0.9,
  delay = 0.2,
  style,
}: {
  d: string;
  viewBox: string;
  className?: string;
  strokeClassName?: string;
  strokeWidth?: number;
  duration?: number;
  delay?: number;
  style?: React.CSSProperties;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <svg
      ref={ref}
      viewBox={viewBox}
      fill="none"
      preserveAspectRatio="none"
      className={`${strokeClassName} ${className}`}
      style={style}
      aria-hidden
    >
      <motion.path
        d={d}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        animate={isInView ? { pathLength: 1 } : {}}
        transition={{ duration, delay, ease: "easeInOut" }}
      />
    </svg>
  );
};
